<!--
    Modal.vue
    -------------------

    This component is basic modal window that allows for content interpolation.
    It requires the following props to be defined:
        * size: The size of the box: "small", "medium", or "large"
        * isOpen: Self-explanatory :)

    It emits the "onCloseClick" event when the window is closed by the user.
-->
<template>
    <div class="confirmation-box-wrapper">
        <div class="reveal-overlay" v-show="isOpen" v-on:click="onCloseClick"></div>
        <div class="confirmation-box reveal" v-bind:class="boxClass" v-show="isOpen">
            <button class="close-button" data-close aria-label="Close reveal" type="button" v-on:click="onCloseClick">
                <span aria-hidden="true">&times;</span>
            </button>

            <!-- content will be inserted here -->
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        props: [
            "size",
            "isOpen"
        ],
        methods: {
            onCloseClick: function () {
                this.$emit("onCloseClick");
            }
        },
        computed: {
            boxClass: function () {
                return {
                    large: this.size === "large",
                    medium: this.size === "medium",
                    small: this.size === "small",
                };
            }
        }
    }

</script>



// WEBPACK FOOTER //
// Modal.vue?3e28dcfc